/**
 * SlidersInit module
 * @module SlidersInit
 * @see module: WTM_Libs
 * @see module: SlidersFactory
 */
define(['wtm_libs','sliders_factory'], (wtm, sliders_factory) => {
    /**
     * Function to iterate wtm.sliders and create swipers
     * @param  {Object}
     * @param  {Object}
     * @return {void}
     */
    ((mainSlider, sliders) => {
        if (wtm.debug_mode) console.log('> Start loading sliders;');
        let display;
        window.innerWidth < 767 ? display = wtm.main_slider.mobile : display = true;
        if (document.getElementById(mainSlider.name) && display) {
            require(['main_slider'], () => {
                new sliders_factory(wtm.main_slider.options);
                if (wtm.debug_mode) console.log('>>> Main slider loaded;');
            });
        }
        for (let obj in sliders) {
            if (document.getElementById(sliders[obj].name)) {
                if (wtm.debug_mode) console.log('>>> Slider: "' + obj + '" loaded;');
                new sliders_factory(sliders[obj].options);
            }
        }
        if (wtm.debug_mode) console.log('> All sliders loaded;');
    })(wtm.main_slider, wtm.sliders);
});
